import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';

const TravelDeals = () => {
  const deals = [
    {
      id: 1,
      city: 'Las Vegas',
      duration: '2h 40m, non-stop',
      startDate: 'Wed 8/20',
      endDate: 'Wed 8/27',
      price: '$684',
      image: 'https://images.unsplash.com/photo-1577334928618-2ff2bf09e827?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8bGFzJTIwdmVnYXN8ZW58MHx8MHx8fDA%3D',
      link: '/flights/BHO-DEL/2025-08-20/2025-08-27/'
    },
    {
      id: 2,
      city: 'Phoenix',
      duration: '2h 20m, non-stop',
      startDate: 'Tue 8/19',
      endDate: 'Tue 8/26',
      price: '$96',
      image: 'https://media.istockphoto.com/id/1288752517/photo/phoenix-arizona-skyline-at-dusk.webp?a=1&b=1&s=612x612&w=0&k=20&c=kCo4Qiab4vBp6wdpZncvHDgc4UcAFlOuQ5Br9rPlbYQ=',
      link: '/flights/BHO-BOM/2025-08-19/2025-08-26/'
    },
    {
      id: 3,
      city: 'Denver',
      duration: '1h 30m, non-stop',
      startDate: 'Tue 8/19',
      endDate: 'Tue 8/26',
      price: '$105',
      image: 'https://images.unsplash.com/photo-1586740070162-41777c99457f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fERlbnZlcnxlbnwwfHwwfHx8MA%3D%3D',
      link: '/flights/BHO-RPR/2025-08-19/2025-08-26/'
    },
    {
      id: 4,
      city: 'St. Louis',
      duration: '1h 30m, non-stop',
      startDate: 'Sun 8/3',
      endDate: 'Sun 8/10',
      price: '$93',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDtiID45wB-nitz6Ar_dt6baEfqH-7lsDt_A&s',
      link: '/flights/BHO-PNQ/2025-08-03/2025-08-10/'
    }
  ];

  return (
    <Box sx={{ 
      maxWidth: 1740,
      mx: 'auto', 
      px: { xs: 2, sm: 3, md: 6, lg: 10 },
      py: { xs: 4, md: 8 },
      position: 'relative'
    }}>
      {/* Header */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        mb: 3 
      }}>
        <Typography variant="h4" sx={{ 
          fontWeight: 700, 
          fontSize: '32px', 
          color: '#181A1B',
          fontFamily: 'inherit',
          lineHeight: '32px'
        }}>
          Travel deals under $436
        </Typography>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          '&:hover': {
            color: '#1976d2'
          }
        }}>
          <Typography sx={{ 
            fontSize: '16px', 
            fontWeight: 500,
            color: '#1976d2'
          }}>
            Explore more
          </Typography>
          <ChevronRight sx={{ fontSize: '20px', color: '#1976d2' }} />
        </Box>
      </Box>

      {/* Cards Container */}
      <Box sx={{ 
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(4, 1fr)'
        },
        gap: { xs: 2, md: 3 },
        padding: { xs: '8px 0 16px', md: '8px 8px 24px' },
        position: 'relative'
      }}>
        {deals.map((deal) => (
          <Box
            key={deal.id}
            sx={{
              backgroundColor: '#fff',
              borderRadius: '32px',
              overflow: 'hidden',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: '1px solid #e0e0e0',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              '&:hover': {
                boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                transform: 'scale(1.02)'
              }
            }}
            onClick={() => window.open(deal.link, '_blank')}
          >
            {/* Image Container */}
            <Box sx={{ 
              width: '95%', 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              margin: '8px auto' 
            }}>
              <Box
                sx={{
                  height: '180px',
                  width: '100%',
                  backgroundColor: deal.image ? 'transparent' : '#f0f0f0',
                  backgroundImage: deal.image ? `url(${deal.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRadius: '32px',
                  ...((!deal.image) && {
                    background: 'linear-gradient(90deg, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 2s infinite',
                    '@keyframes shimmer': {
                      '0%': {
                        backgroundPosition: '-200% 0'
                      },
                      '100%': {
                        backgroundPosition: '200% 0'
                      }
                    }
                  })
                }}
              />
            </Box>

            {/* Content */}
            <Box sx={{ p: 3 }}>
              {/* Title */}
              <Typography sx={{
                fontWeight: 700,
                fontSize: '20px',
                color: '#181A1B',
                mb: 1.5,
                fontFamily: 'inherit'
              }}>
                {deal.city}
              </Typography>

              {/* Duration */}
              <Typography sx={{
                fontSize: '14px',
                color: '#5F6368',
                mb: 1,
                fontFamily: 'inherit'
              }}>
                {deal.duration}
              </Typography>

              {/* Dates */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: 1,
                mb: 3
              }}>
                <Typography sx={{
                  fontSize: '14px',
                  color: '#5F6368',
                  fontFamily: 'inherit'
                }}>
                  {deal.startDate}
                </Typography>
                
                <svg 
                  viewBox="0 0 200 200" 
                  width="12" 
                  height="12" 
                  xmlns="http://www.w3.org/2000/svg" 
                  style={{ color: '#5F6368' }}
                >
                  <path d="M77 50v100l46.1-50z" fill="currentColor" />
                </svg>
                
                <Typography sx={{
                  fontSize: '14px',
                  color: '#5F6368',
                  fontFamily: 'inherit'
                }}>
                  {deal.endDate}
                </Typography>
              </Box>

              {/* Price */}
              <Typography sx={{
                fontFamily: "'TT Hoves Variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                fontWeight: 600,
                fontSize: '24px',
                lineHeight: '32px',
                fontFeatureSettings: "'ss04', 'ss05'",
                color: '#181A1B'
              }}>
                from {deal.price}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>

      {/* Navigation Arrows - Static Buttons */}
      <Box sx={{
        position: 'absolute',
        bottom: '8px',
        right: '8px',
        display: 'flex',
        gap: 1
      }}>
        <IconButton
          sx={{
            width: 40,
            height: 40,
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            color: '#5F6368',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              borderColor: '#d0d0d0'
            }
          }}
        >
          <ChevronLeft sx={{ fontSize: '20px' }} />
        </IconButton>
        <IconButton
          sx={{
            width: 40,
            height: 40,
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            color: '#181A1B',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              borderColor: '#d0d0d0'
            }
          }}
        >
          <ChevronRight sx={{ fontSize: '20px' }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TravelDeals;